import React, {Component} from 'react';
import {Link} from "react-router-dom";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {Button} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';
import {CircularProgress} from "@material-ui/core";
import {ServiceLocator} from "../../Services/ServiceLocator";
import { AuthenticationService } from '../../Services/AuthenticationService';

class Login extends Component {
    state = {
        email: '',
        password: '',
        errorMessage: ''
    };

    constructor(props) {
        super(props);
        globalProps = props;

        // Check for timeout error in URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const error = urlParams.get('error');
        if (error === 'timeout') {
            this.setState({ errorMessage: 'Your login timed out, please try again.' });
        } else if (error === 'access') {
            this.setState({ errorMessage: 'This account does not have administrator access.' });
        }

        // Check if user is already logged in using AuthenticationService
        const authService = AuthenticationService.getInstance();
        if (authService.isLoggedIn()) {
            const user = authService.getUser();
            if (user && user.isAdministrator === true) {
                this.handleLogin(user);
            } else if (user) {
                authService.denyNonAdministratorAccess();
            }
        }
    }

    render() {
        return (
            <div className="login-background">
                <MuiThemeProvider>
                    <img src={require('../../JXB Logo.png')} alt="JXB Performance" style={{width: 200, margin: '20px auto 0'}} />
                    <div className="container" style={{maxWidth: 400, marginTop: 20, padding: '25px 10px'}}>
                        {this.state.errorMessage && (
                            <div style={{ 
                                backgroundColor: '#f44336', 
                                color: 'white', 
                                padding: '10px', 
                                borderRadius: '4px', 
                                marginBottom: '20px',
                                textAlign: 'center'
                            }}>
                                {this.state.errorMessage}
                            </div>
                        )}
                        <div>
                            <TextField
                                placeholder="Enter your email"
                                label="Email"
                                variant="outlined"
                                autoComplete="off"
                                onChange={(event) => this.setState({email: event.target.value})}
                                onKeyPress={(event) => {
                                    this.handleEnter(event);
                                }}
                            />
                            <br/><br/>
                            <TextField
                                type="password"
                                placeholder="Enter your password"
                                label="Password"
                                variant="outlined"
                                autoComplete="off"
                                onChange={(event) => this.setState({password: event.target.value})}
                                onKeyPress={(event) => {
                                    this.handleEnter(event);
                                }}
                            />
                            <div ref="btnLogin" style={{display: 'block'}}>
                                <Button label="Sign in" primary={true} style={{margin: 15, minWidth: 120}}
                                              className="success-button-lg"
                                              onClick={(event) => this.loginUser(event)}>Sign in</Button>
                            </div>
                            <div ref="divLoading" style={{display: 'none'}}>
                                <br/>
                                <CircularProgress />
                            </div>
                        </div>
                        <br/>
                        <div style={{fontWeight: 600, fontSize: 16}}>
                            Need to reset your password?
                        </div>
                        <div>
                            <Link to="/password/forgot">
                                <Button label="Forgot password" primary={true}
                                       className="success-button-lg"
                                       style={style}>Forgot password</Button>
                            </Link>
                        </div>
                        <br />
                        <center>&#9400; {new Date().getFullYear()} JXB Performance, All rights reserved.</center>
                    </div>
                </MuiThemeProvider>
            </div>
        );
    }

    handleEnter(event) {
        if (event.key === 'Enter') {
            this.loginUser(event);
            event.preventDefault();
        }
    }

    loginUser = () => {
        const self = this;
        const authService = AuthenticationService.getInstance();

        const userService = ServiceLocator.Instance.getUserService();
        if (this.state.email.length > 0 && this.state.password.length > 0) {
            self.refs.btnLogin.style = "display: none;";
            self.refs.divLoading.style = "display: block;";
            userService.loginUser(this.state.email, this.state.password).then((authorizationResponse) => {
                const user = authorizationResponse;

                self.refs.btnLogin.style = "display: block";
                self.refs.divLoading.style = "display: none;";

                if (user.isAdministrator !== true) {
                    self.setState({
                        errorMessage: 'This account does not have administrator access.'
                    });
                    return;
                }

                authService.login(user);
                self.handleLogin(user);
            }).catch(function (error) {
                if (error.toString().indexOf('404') > -1) {
                    window.$alertError("Email and password do not match.");
                    self.refs.btnLogin.style = "display: block";
                    self.refs.divLoading.style = "display: none;";
                } else {
                    window.$alertError("Oops, something went wrong.");
                    console.log(error);
                    self.refs.btnLogin.style = "display: block";
                    self.refs.divLoading.style = "display: none;";
                }
            });
        } else {
            window.$alertError("Enter your email and password and try again.");
            self.refs.btnLogin.style = "display: block";
            self.refs.divLoading.style = "display: none;";
        }
    };

    handleLogin = (user) => {
        const redirect = globalProps.match.params.redirect;
        const urlParams = new URLSearchParams(window.location.search);
        const redirectParam = urlParams.get('redirect');
        
        if (redirect === 'redirect' || redirectParam) {
            const redirectPath = redirectParam || '/admin/parts';
            globalProps.history.push(redirectPath);
        } else {
            globalProps.history.push('/admin/parts');
        }
    }
}

let globalProps;

const style = {
    margin: 15
};

export default Login;
